import { SupportedLocale } from "types";

export const LANGUAGE_UPDATE_START = 'LANGUAGE_UPDATE_START';
export const LANGUAGE_UPDATE_COMPLETED = 'LANGUAGE_UPDATE_COMPLETED';
export const LANGUAGE_UPDATE_ERROR = 'LANGUAGE_UPDATE_ERROR';


export const updateUserLanguage = (language: SupportedLocale) => {
    return {
        type: LANGUAGE_UPDATE_START,
        payload: { userLanguage: language }
    };
};

export const updateUserLanguageCompleted = (language: SupportedLocale) => {
    return {
        type: LANGUAGE_UPDATE_COMPLETED,
        payload: { userLanguage: language }
    };
};

export const updateUserLanguageError = (error: any) => {
    return {
        type: LANGUAGE_UPDATE_ERROR,
        payload: {},
        error: error
    };
};
